import Vue from 'vue'
import render from './render.vue'

const _i18n = null
let instance
let instances = []
let seed = 1

const Render = Vue.extend(render)

const RenderEvent = function (parentDom, propsData) {
  if (Vue.prototype.$isServer) return
  this.removeAll = removeAll
  Vue.prototype._i18n = _i18n
  const options = {}
  const id = `rend_${seed++}`
  instance = new Render({
    propsData,
    data: options
  })
  instance.id = id
  instance.parentDom = parentDom
  instance.$mount()
  parentDom.appendChild(instance.$el)
  instances.push(instance)
}
const removeAll = function () {
  instances.forEach((instanceItem) => {
    (instanceItem.parentDom || document.body).removeChild(instanceItem.$el)
  })
  instances = []
  return null
}

export default RenderEvent
